import './PlanSubmitApproveRejectTask.style.less'

import PlanTaskLayout from '../../Layouts/PlanTaskLayout'

interface Prop {
  data: any
}

export function PlanSubmitApproveRejectTask(prop: Prop) {
  const { data } = prop

  return <PlanTaskLayout data={data} planLabel={`Plan`} />
}

export default PlanSubmitApproveRejectTask
